import { Directive } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

@Directive({
  selector: '[ErrorHandler]',
})
export class ErrorHandlerDirective {
  DEFAULT_ERROR_MSG = "Something went wrong... Please try again later.";
  DEFAULT_REF_DIV_ID = "errorhandler";
  DEFAULT_ERROR_DIV_ID = "errorMsg";
  DANGER = "errorMsgDanger";
  SUCCESS = "success-msg";
  private subscriptions: any[] = [];

  constructor(public toastr: ToastrService, private route: Router) { }

  public getErrorCode(response: any) {
    let result;
    let errorCode = "";
    try {
      result = JSON.parse(response.error.message);
    } catch (e) {
      return errorCode;
    }
    const errorList = [];
    if (result?.errorIds !== null && result.errorIds !== "") {
      for (let i = 0; i < result.errorIds.length; i++) {
        errorList.push(result.errorIds[i]);
      }
    }
    if (errorList.length > 0) {
      errorCode = errorList[0].errorCode;
    }
    return errorCode;
  }

  public getMessage(response: any) {
    const fatalErrorList: any[] = [];
    const generalErrorList: any[] = [];
    if (!response?.error?.message) {
      if (
        response.error.status === 401 ||
        response.error.httpStatus === "UNAUTHORIZED" ||
        response.error.status === 403
      ) {
        const errorMessage = response?.error?.error;
        this.toastr.error(errorMessage);
        if (response.error.status === 401) {
          this.route.navigateByUrl("login");
        }
        return;
      }
    }
    this.displayError(response, generalErrorList, fatalErrorList);
  }

  // Not used now, will be used in future
  public showErrorMessage(errorMsg: any, refDivId: any) {
    // remove first if any previous error message displayed
    this.removeErrorMessage();
    // setting default error message. eg. - something went wrong & Message Property
    const errorMsgDivId = this.DEFAULT_ERROR_DIV_ID;
    const errorMsgDivClass = this.DANGER;
    if (errorMsg === undefined || errorMsg === null) {
      errorMsg = this.DEFAULT_ERROR_MSG;
    }
    if (refDivId === undefined || document.getElementById(refDivId) === null) {
      refDivId = this.DEFAULT_REF_DIV_ID;
    }
    const errorMsgElement = document.createElement("div");
    errorMsgElement.setAttribute("class", errorMsgDivClass);
    errorMsgElement.setAttribute("id", errorMsgDivId);

    // errorMsg carries server-supplied text, so the message is built as nodes: with
    // innerHTML any markup in it would be parsed and executed.
    const closeIcon = document.createElement("i");
    closeIcon.setAttribute("class", "fa fa-times");
    closeIcon.style.margin = "5px";
    closeIcon.addEventListener("click", () => errorMsgElement.remove());

    const messageWrapper = document.createElement("span");
    const messageText = document.createElement("b");
    messageText.textContent = String(errorMsg);
    messageWrapper.appendChild(messageText);

    errorMsgElement.appendChild(closeIcon);
    errorMsgElement.appendChild(messageWrapper);
    return;
  }

  unsubscribe() {
    for (let index = 0; index < this.subscriptions.length; index++) {
      const subscription = this.subscriptions[index];
      if (subscription) {
        subscription.unsubscribe();
        this.subscriptions.splice(index, 1);
      }
    }
  }

  public removeErrorMessage() {
    const errorMsgDivId = this.DEFAULT_ERROR_DIV_ID;
    if (
      errorMsgDivId !== undefined &&
      document.getElementById(errorMsgDivId) !== null
    ) {
      document.getElementById(errorMsgDivId)?.remove();
    }
    return this.DEFAULT_REF_DIV_ID;
  }

  private displayError(
    response: any,
    generalErrorList: any[],
    fatalErrorList: any[]
  ) {
    let result;
    try {
      if (response.error.status === 500) {
        result = "";
      } else {
        result = JSON.parse(response.error.message);
      }
    } catch (e) {
      generalErrorList.push({ errorMessage: "Something went wrong.." });
      this.getErrorMessage({
        fatalErrorList: fatalErrorList,
        generalErrorList: generalErrorList,
      });
    }

    if (result?.errorIds !== null && result.errorIds !== "") {
      for (let i = 0; i < result.errorIds.length; i++) {
        if (result.errorIds[i].severity === "FATAL") {
          fatalErrorList.push(result.errorIds[i]);
        } else {
          generalErrorList.push(result.errorIds[i]);
        }
      }
      this.getErrorMessage({
        fatalErrorList: fatalErrorList,
        generalErrorList: generalErrorList,
      });
    }
  }

  private getErrorMessage = (errorList: any) => {
    let errorMessage = this.DEFAULT_ERROR_MSG;
    if (errorList?.generalErrorList) {
      if (
        errorList.generalErrorList[0] !== undefined &&
        errorList.generalErrorList[0].errorMessage !== undefined
      ) {
        errorMessage = errorList.generalErrorList[0].errorMessage;

        if (
          errorList.generalErrorList[0].hints !== undefined &&
          errorList.generalErrorList[0].hints.length > 0
        ) {
          for (let i = 0; i < errorList.generalErrorList[0].hints.length; i++) {
            errorMessage =
              errorMessage +
              ". " +
              errorList.generalErrorList[0].hints[i].hintKey +
              " " +
              errorList.generalErrorList[0].hints[i].hintValue;
          }
        }
      } else if (
        errorList.fatalErrorList[0] !== undefined &&
        errorList.fatalErrorList[0].errorMessage !== undefined
      ) {
        errorMessage = errorList.fatalErrorList[0].errorMessage;
      }
    }
    if (errorMessage && errorMessage !== "") {
      this.toastr.error(errorMessage, "", {
        timeOut: 2000,
      });
    }
  };
}
